import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './PublicLayout.css';

function PublicLayout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="public-layout">
      <header className="public-layout__header">
        <Link to="/about" className="public-layout__wordmark">
          Remori
        </Link>
        <nav className="public-layout__nav">
          <Link to="/about" className="public-layout__nav-link">About</Link>
          <Link to="/privacy" className="public-layout__nav-link">Privacy</Link>
          <Link to="/terms" className="public-layout__nav-link">Terms</Link>
        </nav>
        <button
          className="public-layout__cta"
          onClick={() => navigate('/')}
        >
          Open App
        </button>
      </header>

      <main className="public-layout__main">
        {children}
      </main>

      <footer className="public-layout__footer">
        <div className="public-layout__footer-inner">
          <span className="public-layout__footer-brand">
            &copy; {new Date().getFullYear()} Remori. All rights reserved.
          </span>
          <div className="public-layout__footer-links">
            <Link to="/about" className="public-layout__footer-link">About</Link>
            <Link to="/privacy" className="public-layout__footer-link">Privacy</Link>
            <Link to="/terms" className="public-layout__footer-link">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PublicLayout;
